export function validateQueryName(rule, value, callback) {
  if (!value?.trim()) {
    callback('Please enter a valid query name');
  }
  callback();
}
